module.exports = __webpack_public_path__ + "img/send-money.7ab3ce7e.png";